import { render, staticRenderFns } from "./DocumentoaduaneroFormHeader.vue?vue&type=template&id=288a137c"
import script from "./DocumentoaduaneroFormHeader.vue?vue&type=script&lang=js"
export * from "./DocumentoaduaneroFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports